import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress
} from "@material-ui/core";
import BackupIcon from '@material-ui/icons/Backup';
import csv from "csvtojson";
import apiManager from "../../../ApiManager";
import { flattenResponse } from "../../../utils/flatten";
import { ORGANIZATION_ALIAS } from '../../../constants';

export default function UsageReportDialog({
  onClose,
  downloadCSV,
}) {

  //Form variables and handler
  const [progress, setProgress] = useState(0);
  const [processing, setProcessing] = useState(true);
  const [users, setUsers] = useState([]);
  const [userToProcess, setUserToProcess] = useState(-1);
  const [page, setPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const pageSize = 250;
  const [userIndex, setUserIndex] = useState(0);
  const [organization, setOrganization] = useState(localStorage.getItem('organization') ? JSON.parse(localStorage.getItem('organization')) : '');
  const [courses, setCourses] = useState([]);
  const [subs, setSubs] = useState([]);
  const csvArray = [];
  const filterString = {course: [],
    membergroup: [],
    membertype: [],
    referral: [],
    role: [],
    source:[],
    subscription:["Stripe", "Manual"],
    };

  const loadUsers = async() => {
 
    const payload = {
      page, pageSize, sortBy: "created-down", sortDir: 1, filterString, orgAlias: ORGANIZATION_ALIAS, exclude: 'admins'
  };
    const response = await apiManager.getUserList(payload);
    const flatUsers = flattenResponse(response);
    debugger;
    if( page === 1) {
      setTotalUsers(response.count || 0);
    }
    setUsers(flatUsers);
    setUserIndex(0);  // first of pageSize users in this set.
    setUserToProcess(userToProcess + 1);
  }

  useEffect(() => {
    loadUsers();
  }, [page]);

  useEffect(() => {
    setCourses(organization.courses);
    let sub = [...organization.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, processedBy: ''}));
    setSubs(sub);
  },[organization]);


  const processNextUser = async () => {
    const newProgress = totalUsers === 0 ? 0 : (100 - (100 * (totalUsers - userToProcess)) / totalUsers);
    setProgress( newProgress );

    const utp = userToProcess + 1;
    if (utp > totalUsers) {
      // then finished
      setProgress(100);
      setProcessing(false);
    } else {
      // get progress from next user and add to csv data set
      const udata = users[userIndex];
      if (!udata) {
        debugger;
      }
             
      if( udata.email === 'eddie+sha03@curve10.com') {
        debugger; // testing
      }
      if (udata.organization_subscriptions && !udata.guestIds_0) {
        debugger;
      }
      if (udata.organization_subscriptions && udata.guestIds_0) {
        for( let is = 0; is < subs.length; is++) {
          const sub = subs[is];
          // see if we have progress for this sub
            for (let io = 0; io < udata.organization_subscriptions.length; io++) {
            const orgSub = udata.organization_subscriptions[io];
            if (orgSub.courseNameAlias === sub.alias) {
              // ok, found it.. do we need to render the progress report?
      
              if (orgSub.isSubscribed && (!orgSub.progress || orgSub.progressUpdate < udata.lastLogin)) {
                // must calculate this one
                const p = true;
                const newProgress = await apiManager.getClassProgress(organization.organization.alias, sub.alias, udata.cognitoId);
                debugger;
                console.log(newProgress)
              } 
            }
          }
        }
      }


      if (userIndex + 1 >= pageSize) {
        setPage(page + 1);
      } else {
        setUserIndex(userIndex + 1);
        setUserToProcess(userToProcess + 1);
      }
    }
  };

  useEffect(() => {
    if (userToProcess >= 0) {
      processNextUser()
    }
  }, [userToProcess]);


  
  const downloadTemplate = () => {
    const csvTemplate = ['PLEASE READ THESE INSTRUCTIONS: Add your data starting in row 4. When you are finished delete lines 1 and 2. Then save your file (in .csv format) and upload.\n NOTES: The only required fields are name (firstName and lastName) and email. The value for each course a user is subscribed to (regenag-101 etc.) should be "yes" (no quotes and lower case).\nfirstName',"lastName","email", "phone", "city", "state", "postalCode", "group", "regenag-101", "grazing", "cropping", "couponCode"]; //set the data
    let csvContent =  "data:text/csv;charset=utf-8," + csvTemplate //combine data with doc type, use map if more than one row
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "UAg_user_upload_template.csv"); //change file name here
    document.body.appendChild(link);
    link.click() //trigger download
  }

  const closeAndDownload = () => {
    downloadCSV(filterString);
    onClose();
  }

  return (
    <Dialog
      open={true}
      onClose={null}
      fullWidth={true}
      maxWidth={"xs"}
      aria-labelledby="Usage Report Popup"
    >
       <DialogTitle>Usage Report</DialogTitle>
       <DialogContent>
        <>
        {processing
        ?
        <> 
                <div style={{padding: 24, textAlign: 'center', marginTop: 20}}>
                    <LinearProgress variant="determinate" value={progress} />
                    <br />
                    <span style={{fontFamily: 'sans-serif'}}>Processing</span>
                </div>
        </>
        :
        <span style={{fontFamily: 'sans-serif'}}>  Processing complete. Ready to download.</span>
        }
        </>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={closeAndDownload} variant="contained" color="primary" disabled={processing} >Download</Button>
        </DialogActions>
    </Dialog>
  );
}
